export * from "-!../../../../../../../../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../../../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./sport-column-banners.vue?vue&type=template&id=3fd131b6"


//////////////////
// WEBPACK FOOTER
// ./skins/bulmasite/components/common/banners/sport-banners/sport-column-banners.vue?vue&type=template&id=3fd131b6
// module id = SV1N
// module chunks = 0